// @flow
import React, { memo, useContext } from 'react';
import { Environment } from '@ta/lithium.context';
import { useLocalize } from '@ta/platform.i18n';
import Header from './Header';
import styles from './HasDestinationPicker.css';

type Props = {|
  displayName: ?string,
  onSelect: boolean => mixed,
|};

/**
 * A picker that allow the user to choose to plan a trip, or skip the flow.
 */
const HasDestinationPicker = ({ displayName, onSelect }: Props) => {
  const { localize } = useLocalize();
  const { cdnPrefix } = useContext(Environment);

  return (
    <>
      <div className={styles.imageContainer}>
        <img
          className={styles.image}
          src={`${cdnPrefix}/img2/cx/explicit_preferences/welcome2.jpeg`}
          srcSet={`
          ${cdnPrefix}/img2/cx/explicit_preferences/welcome2.jpeg 1x,
          ${cdnPrefix}/img2/cx/explicit_preferences/welcome2@2x.jpeg 2x
        `}
          alt=""
        />
      </div>

      <div className={styles.contents}>
        <Header
          titleText={
            displayName
              ? // Hi, {displayName}. Let's help you plan a trip you'll love.
                localize('cx_explicit_preferences_welcome_header3', { displayName })
              : // Thanks. Now, let's help you plan a trip you'll love.
                localize('cx_explicit_preferences_welcome_header_no_name2')
          }
          // Answer some questions about your trip so we can show you more personalized ideas.
          subtitleText={localize('cx_explicit_preferences_welcome_subheader2')}
          withBackground={false}
        />

        <div className={styles.options}>
          <button className={`${styles.option} ${styles.yes}`} onClick={() => onSelect(true)}>
            {localize('cx_explicit_preferences_welcome_yes') /* Yes, let's go */}
          </button>

          <button className={`${styles.option} ${styles.no}`} onClick={() => onSelect(false)}>
            {localize('cx_explicit_preferences_welcome_no') /* No thanks */}
          </button>
        </div>
      </div>
    </>
  );
};

export default memo<Props>(HasDestinationPicker);
